import React, { FC } from "react";
import { Box, Button, Divider } from "@chakra-ui/react";
import { TGrsPendingLeadDetail } from "types/grs-pending-lead.type";
import { GrsPendingLeadDetailsPanel } from "./GrsPendingLeadDetailsPanel";

interface IGrsPendingLeadReviewStepProps {
  detail: TGrsPendingLeadDetail;
  onReject: () => void;
  onAccept: () => void;
}

export const GrsPendingLeadReviewStep: FC<IGrsPendingLeadReviewStepProps> = ({
  detail,
  onReject,
  onAccept,
}) => {
  return (
    <Box>
      <Box mb={5} color={"leadpro.700"}>
        Below are the details of a pending lead from Nurtur GRS. Review these
        details and choose to accept or reject this pending lead.
      </Box>
      <GrsPendingLeadDetailsPanel detail={detail} />
      <Divider mb={4} />
      <Box display={"flex"} justifyContent={"flex-end"}>
        <Button
          mr={3}
          bg={"leadpro.500"}
          color={"white"}
          _hover={{ bg: "leadpro.700" }}
          _active={{ bg: "leadpro.700" }}
          onClick={onReject}
        >
          Reject
        </Button>
        <Button
          bg={"cyan.800"}
          color={"white"}
          _hover={{ bg: "cyan.900" }}
          _active={{ bg: "cyan.900" }}
          onClick={onAccept}
        >
          Accept
        </Button>
      </Box>
    </Box>
  );
};
